import { Controller } from "@hotwired/stimulus"

// Phase 2.12 Tier 4 Step 37 — inflation normalization toggle.
//
// Persists the user's choice (`""` = nominal, `"cpi_us"`, `"enr_cci"`)
// to `user_settings.portfolio_inflation_normalize` via the existing
// `PUT /users/:id/update_settings` endpoint, then reloads the page so
// every dollar tile + the project table picks up the new multiplier.
//
// `Inflation Normalization Toggled` Mixpanel event is fired
// server-side (UsersController#update_settings) so it survives ad
// blockers; nothing client-side is needed.
export default class extends Controller {
  static values = {
    url:     String,
    current: String
  }

  select(event) {
    const kind = (event.params.kind ?? "").toString()
    if (kind === this.currentValue) return

    if (!this.urlValue) return

    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    const fd = new FormData()
    fd.append("setting[portfolio_inflation_normalize]", kind)

    fetch(this.urlValue, {
      method: "PUT",
      headers: { "X-CSRF-Token": csrf, "Accept": "*/*" },
      credentials: "same-origin",
      body: fd
    })
      .then(r => {
        if (r.ok) {
          window.location.reload()
        } else {
          console.warn("[inflation-toggle] save failed", r.status)
        }
      })
      .catch(err => console.warn("[inflation-toggle] save error", err))
  }
}
